import { Component, Input, Output, EventEmitter, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl,ValidationErrors } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { UserServiceA2P } from '../services/userA2P.service';
import { SessionService } from '../services/session.service';
import { ValidarCodA2P } from '../entities/validarCodA2P.entity';
import { AlertBoxComponent } from '../shared/alertbox.component';
import { Respuesta } from '../entities/respuesta.entity';
import { UserService } from '../services/user.service';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FormatoTelefono, Naciones } from '../entities/naciones';
import { Validator } from 'class-validator';
import { HttpService } from '../services/http.service';

@Component({
  selector: 'app-valTlfA2P-modal',
  templateUrl: './valTlfA2P.component.html',
  styleUrls: ['./valCodA2P.component.css'] 
})

export class ValTlfA2PComponent implements OnInit {
   
    @Input() title = 'Verificar teléfono:'; 
    @Input() explotacion : string; 

    @Output() closeModal = new EventEmitter<void>();     
    @Output() submitModal = new EventEmitter<void>();

    @Output() messageCabecera = new EventEmitter<string>();
    @Output() typeException = new EventEmitter<number>();
    @Output() messageCompleto = new EventEmitter<string>();

    @Output() sendTelephone = new EventEmitter<FormatoTelefono>();

    public form: FormGroup;
    public visible = false;
    public resultado: Respuesta;
    public message = '';
    
    public errorMessage: string | null = null;
    public successMessage: string | null = null;
    private timerMessage: any = null;
    public hideBody = false;
    public canInteract = false; 
    public codigosTelefono: Naciones[];

    constructor(private userService: UserService, private sessionService: SessionService, private userServiceA2P : UserServiceA2P,private fb: FormBuilder,private httpService: HttpService) {
        this.form = this.fb.group({
            number: ['', [Validators.required]],
            tlfCod: ['+34', [Validators.required]]
        });
     }

    public ngOnInit() {
        this.message = "Introduzca el número de teléfono, para autenticación multifactor via SMS.";
        this.getNaciones();
    }
    
    public  onNumberInput(evt: Event): void {
        if(this.form.valid){
            const input = evt.target as HTMLInputElement;
            const cleaned = (input.value || '').replace(/\D/g, ''); 

            if (input.value !== cleaned) {
                input.value = cleaned;    
                const numberCtrl = this.number; 
                
                if (numberCtrl) 
                    numberCtrl.setValue(cleaned);
            }
        }
    }

    public onPaste(evt: ClipboardEvent): void {
        evt.preventDefault();

        let text = '';
        if (evt.clipboardData && typeof evt.clipboardData.getData === 'function') {
            text = evt.clipboardData.getData('text') || '';
        } else {
            const w = window as any;
            if (w.clipboardData && typeof w.clipboardData.getData === 'function') {
                text = w.clipboardData.getData('Text') || '';
            }
        }
        const cleaned = text.replace(/\D/g, '');
        const input = evt.target as HTMLInputElement;
        input.value = cleaned;
        
        const numberCtrl = this.number;
        if (numberCtrl) {
            numberCtrl.setValue(cleaned);
        }
    }

    get number(): AbstractControl { return this.form ?  this.form.get('number') : null; }

    public close() {
        this.closeModal.emit();
    }

    public submitForm() {
        if (this.form.valid) {
            this.sendTelephone.emit({
                CodigoTelefono : this.form.get('tlfCod').value,
                Numero: this.number.value
            });
            this.showMessage("Se enviará un SMS a continuación para su validación.",'success');
        } else {
            this.form.get('number')!.markAsTouched();
            this.showMessage("Teléfono no válido.",'error');
        }
    }
    
    private showMessage(message: string, type: 'success' | 'error') {
        if (this.timerMessage) {
            clearTimeout(this.timerMessage);
            this.timerMessage = null;
        }
        this.hideBody = false;
        if (type === 'success'){ 
            this.successMessage = message;
            this.hideBody = true;
            this.httpService.showSpinner();
        }else 
            this.errorMessage = message;    

        this.timerMessage = setTimeout(() => {
        this.successMessage = null;
        this.errorMessage = null;
        this.timerMessage = null;
        if (type === 'success')         
            this.submitModal.emit();
        }, 3000);
    }
    
      /**
     * Obtiene la lista de códigos de teléfono por país.
     * @param {string} explotacion - Código de explotación.
     * @returns {Observable<any>} - Un observable que contiene la lista de naciones para la explotación especificada.
     */
      private getNaciones(){
        this.userService.getNaciones(this.explotacion).subscribe(
          data => {
            this.codigosTelefono = data;
          },
          error => {
            this.showMessage('Error al obtener los códigos de teléfono','error');
          }
        );
      }
}


// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/public/valTlfA2P.component.ts